import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import { InfoOutlined, AddCircleOutline } from "@mui/icons-material";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import { useDispatch } from "react-redux";
import classes from "./Setting.module.css";
import { useContext } from "react";
import { DiscoveryContext } from "../discovery-context";

export default function TemplateSettings({
    templateOptions,
    metricSettingId,
    MetricSettingChangeHandle,
    category,
    categoryWiseMetric,
    onCategoryTemplateChange,
    defaultTemplate,
    overrideCount
}) {
    const dispatch = useDispatch();
    const discoveryCtx = useContext(DiscoveryContext);
    const isFinalTransactionCompleted =
        discoveryCtx?.state.finalTransactionStatus === "COMPLETED" ||
        discoveryCtx?.state.finalTransactionStatus === "RETRY";
    const isDisabled = discoveryCtx?.loading || isFinalTransactionCompleted

    function CustomOption(option) {
        let { name, value, isDefault } = option;
        return (
            <span className={isDefault ? classes.isDefault : classes.isNotDefault}>
                {name}
            </span>
        );
    }

    // Custom option renderer for category-level dropdowns
  function CategoryCustomOption(option) {
    let { name, isDefault } = option;

    return (
        <span className={isDefault ? classes.isDefault : classes.isNotDefault}>
            {name}
        </span>
    );
}
    return (
        <div className={classes.templateSection}>
            {/* Global Template Setting */}
            <div className={classes.globalSection}>
                <div className={classes.sectionHeader}>
                    <div>
                        <h4 className={classes.sectionTitle}>
                            Global Template Settings
                            <InfoOutlined className={classes.infoIcon} titleAccess="This template applies to all categories unless explicitly overridden." />
                        </h4>
                        <p className={classes.sectionSubtitle}>Default template for all categories.</p>
                    </div>
                </div>
                <div className={classes.globalSelectContainer}>
                    <div className={classes.selectWrapper}>
                        <MUISelect
                            fullWidth={true}
                            optionValue={metricSettingId}
                            label=""
                            options={templateOptions}
                            disabled={isDisabled}
                            CustomOption={CustomOption}
                            onChange={(e) => {
                                MetricSettingChangeHandle(e.target.value);
                            }}
                        />
                    </div>
                    <MUIIconButton
                        className={classes.addButton}
                        title="Manage Templates"
                        // disabled={isDisabled}
                        onClick={() => {
                            dispatch({ type: "ACTION_MODEL", payload: true });
                        }}
                    >
                        <AddCircleOutline />
                    </MUIIconButton>
                </div>
            </div>

            {/* Category-Specific Overrides */}
            <div className={classes.overridesSection}>
                <div className={classes.overridesHeader}>
                    <h5 className={classes.overridesTitle}>Category-Specific Template Settings</h5>
                    {/* <span className={classes.overrideBadge}>
                        {overrideCount} Override{overrideCount !== 1 ? 's' : ''} Active
                    </span> */}
                </div>

                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr>
                                <th>CATEGORY NAME</th>
                                <th>TEMPLATE</th>
                            </tr>
                        </thead>
                        <tbody>
                            {category.map((cat) => {
                                const isOverride = categoryWiseMetric[cat] &&
                                    categoryWiseMetric[cat] !== metricSettingId;

                                const currentValue = categoryWiseMetric[cat]
                                    ? Number(categoryWiseMetric[cat])
                                    : metricSettingId;
                                return (
                                    <tr key={cat} className={isOverride ? classes.overrideRow : ''}>
                                        <td className={classes.categoryCell}>{cat}</td>
                                        <td className={classes.templateCell}>
                                            <div className={classes.templateCellContent}>
                                                <div className={classes.selectWrapperSmall}>
                                                    <MUISelect
                                                        fullWidth={true}
                                                        optionValue={currentValue}
                                                        label=""
                                                        options={templateOptions}
                                                        disabled={isDisabled}
                                                        CustomOption={(option) => CategoryCustomOption(option, metricSettingId)}
                                                        onChange={(e) => {
                                                            onCategoryTemplateChange({
                                                                category: cat,
                                                                value: e.target.value,
                                                            });
                                                        }}
                                                    />
                                                </div>
                                                {/* {isOverride && (
                                                            <span className={classes.overrideLabel}>Override</span>
                                                        )} */}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}